/* milleniva custom stylesheet sections/main-cart-footer.liquid & assets/cart.js */

window.updateFreeShippingMessageFromCart = function () {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const limit = 0; 
      const total = cart.total_price / 100;
      const container = document.getElementById('free-shipping-message');

      // 1. ADIM: Sitenin o anki dilini alıyoruz (tr veya en)
      // Shopify genellikle 'tr', 'en' veya 'tr-TR' gibi değerler döndürür.
      const currentLang = document.documentElement.lang.substring(0, 2); 

      if (!container) return;

      if (total < limit) {
        // PENDING
        const diff = (limit - total).toFixed(2);
        
        // 2. ADIM: Dile göre mesajı belirliyoruz
        let messageHTML = '';
        
        if (currentLang === 'en') {
          // İngilizce Mesaj
          messageHTML = `You are <strong>${diff} TL</strong> away from free shipping.`;
        } else {
          // Türkçe Mesaj (Varsayılan)
          messageHTML = `Ücretsiz kargo hakkı için <strong>${diff} TL</strong> eksiğiniz var.`;
        }

        container.innerHTML = messageHTML;
        container.className = 'fs-pending';
        container.style = ""; 
        
      } else {
        // SUCCESS
        let successHTML = '';

        if (currentLang === 'en') {
           // İngilizce Mesaj
           successHTML = `✓ FREE SHIPPING ON US!`;
        } else {
           // Türkçe Mesaj
           successHTML = `✓ KARGO BİZDEN!`;
        }

        container.innerHTML = successHTML; 
        container.className = 'fs-success';
        container.style = "";
      }
    });
};

document.addEventListener('DOMContentLoaded', () => {
  window.updateFreeShippingMessageFromCart();
});